import api from '@/api';
import { PageResult } from '@/core/request/PageResult';
import { API_BASE_URL } from '..';
import {
  Informative,
  InformativeCreateRequest,
  InformativeResponse,
  ListInformativeQuery,
} from './Informative.types';

const baseUrl = `${API_BASE_URL}`;

export async function listInformative(
  params?: ListInformativeQuery,
): Promise<PageResult<Informative>> {
  const result = (await api.get(`${baseUrl}/informative`, params)) as unknown;

  return result as PageResult<Informative>;
}

export async function informativeDetail(
  informativeId: number,
): Promise<Informative> {
  const result = (await api.get(
    `${baseUrl}/informative/${informativeId}`,
    null,
  )) as unknown;

  return result as Informative;
}

export async function deleteInformative(id: number) {
  const result = (await api.remove(
    `${baseUrl}/informative/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function createInformative(
  obj: InformativeCreateRequest,
): Promise<InformativeResponse> {
  const result = (await api.post(
    `${baseUrl}/informative`,
    obj,
    null,
  )) as unknown;

  return result as InformativeResponse;
}
